import { SAITAMA_CITY_SEASON_ID } from "../../config/SaitamaCityConfig";

export const buildSaitamaPhotoScope = (photoAlias = "ppa") => `
  ${photoAlias}.game_space_id = '${SAITAMA_CITY_SEASON_ID}'
  AND EXISTS (
    SELECT 1
    FROM power_asset_detail_of_saitama_city sc
    JOIN street_light sl ON sl.id = sc.power_asset_id
    WHERE sc.power_asset_id = ${photoAlias}.power_asset_id
  )
`;

export const buildSaitamaReportScope = (reportAlias = "rr") => `
  ${reportAlias}.game_space_id = '${SAITAMA_CITY_SEASON_ID}'
  AND EXISTS (
    SELECT 1
    FROM power_asset_detail_of_saitama_city sc
    JOIN street_light sl ON sl.id = sc.power_asset_id
    WHERE sc.power_asset_id = ${reportAlias}.power_asset_id
  )
`;

export const buildSaitamaPhotoGroupingCtes = ({
  startUtc = "",
  endUtc = "",
} = {}) => {
  const dateFilter = startUtc && endUtc
    ? `
          AND (
            occurred_datetime IS NULL
            OR (
              occurred_datetime >= '${startUtc}'
              AND occurred_datetime < '${endUtc}'
            )
          )`
    : "";

  return `
    SaitamaPhotoEvents AS (
      SELECT
        ppa.id AS ppa_id,
        ppa.file_name,
        ppa.object_key,
        ppa.power_asset_id,
        ppa.player_id,
        ppa.game_space_id,
        ppa.inspection_photography_angle_of_view_id AS angle_of_view_id,
        pae.id AS photograph_event_id,
        pae.occurred_datetime,
        ROW_NUMBER() OVER (
          PARTITION BY ppa.id
          ORDER BY pae.occurred_datetime DESC, pae.id DESC
        ) AS event_rn
      FROM photo_of_power_asset ppa
      LEFT JOIN power_asset_event pae
        ON pae.game_space_id = ppa.game_space_id
        AND pae.power_asset_id = ppa.power_asset_id
        AND pae.player_id = ppa.player_id
        AND pae.type = 'PHOTOGRAPH'
      WHERE ${buildSaitamaPhotoScope("ppa")}
    ),
    SaitamaFilteredPhotoEvents AS (
      SELECT *
      FROM SaitamaPhotoEvents
      WHERE event_rn = 1
        ${dateFilter}
    ),
    SaitamaPhotoGroups AS (
      SELECT
        fpe.*,
        CASE
          WHEN fpe.photograph_event_id IS NOT NULL
            THEN CONCAT('event:', fpe.photograph_event_id)
          WHEN fpe.file_name REGEXP '^[^_]+_[^_]+_[0-9]{8}_[0-9]{4}_[^_]+\\.(jpg|webp)$'
            THEN CONCAT(
              'file:', fpe.game_space_id, ':', fpe.power_asset_id, ':',
              fpe.player_id, ':',
              SUBSTRING_INDEX(SUBSTRING_INDEX(fpe.file_name, '_', 4), '_', -2)
            )
          ELSE CONCAT('photo:', fpe.ppa_id)
        END AS logical_group_key
      FROM SaitamaFilteredPhotoEvents fpe
    ),
    SaitamaFirstCaptureCandidates AS (
      SELECT
        spg.power_asset_id,
        spg.photograph_event_id,
        MIN(spg.occurred_datetime) AS photography_datetime,
        ROW_NUMBER() OVER (
          PARTITION BY spg.power_asset_id
          ORDER BY MIN(spg.occurred_datetime) ASC, spg.photograph_event_id ASC
        ) AS first_capture_rn
      FROM SaitamaPhotoGroups spg
      WHERE spg.photograph_event_id IS NOT NULL
      GROUP BY spg.power_asset_id, spg.photograph_event_id
    ),
    SaitamaRankedPhotoGroups AS (
      SELECT
        pg.*,
        fcr.first_capture_rn,
        ROW_NUMBER() OVER (
          PARTITION BY pg.logical_group_key
          ORDER BY
            CASE
              WHEN pg.angle_of_view_id REGEXP '^[0-9]+$'
                THEN CAST(pg.angle_of_view_id AS UNSIGNED)
              ELSE 999999
            END,
            pg.ppa_id DESC
        ) AS group_rn
      FROM SaitamaPhotoGroups pg
      LEFT JOIN SaitamaFirstCaptureCandidates fcr
        ON fcr.power_asset_id = pg.power_asset_id
        AND fcr.photograph_event_id = pg.photograph_event_id
    )
  `;
};
